import Vue from 'vue';
import DomainStore from '@/app-shared/domain-store/index';
import {
  setBaseUrl,
  setRequestHeaders,
  setResponseInterceptors,
  useDocServer,
  useInteractiveServer,
  useRoomBaseServer,
  useMicServer,
  useMediaSettingServer,
  useVirtualAudienceServer,
  useUserServer,
  useGroupServer,
  useDesktopShareServer,
  useSplitScreenServer,
  useInsertFileServer,
  useMediaCheckServer,
  useVideoPollingServer,
  useChatServer,
  usePlayerServer,
  useSubscribeServer,
  useSubjectServer,
  useFileDownloadServer,
  useAiServer,
  useAiOutlineServer,
  useGoodServer,
  usePlaybackServer,
  setEnv,
  setApiEnv
} from 'middle-domain';
import { removeToken } from '@vhcl/saas-login';
setApiEnv(process.env.VUE_APP_API_ENV || process.env.VUE_APP_ENV);
setEnv(process.env.VUE_APP_ENV);
// 2024-06-19 webcasting及event统一处理接口预检
// http://wiki.vhallops.com/pages/viewpage.action?pageId=371264939
setBaseUrl({
  v3Url: process.env.VUE_APP_HOMOLOGOUS ? '' : process.env.VUE_APP_BASE_URL,
  wxBindBaseUrl: process.env.VUE_APP_HOMOLOGOUS ? '' : process.env.VUE_APP_BIND_BASE_URL,
  marketUrl: process.env.VUE_APP_HOMOLOGOUS ? '' : process.env.VUE_APP_MARKET_SERVICE_URL, // 新营销中心接口
  isHomologous: process.env.VUE_APP_SAAS_ENV == 'development' ? false : true,
  bizId: process.env.VUE_APP_BIZ_ID || 2,
  shortLinkBaseUrl: process.env.VUE_APP_SHORTlINK_URL // 短链接口基础地址
});

/**
 * 平台标识
 * wiki:
 */
setRequestHeaders({
  platform: 7
});
setResponseInterceptors(e => {
  //如果是token失效，清空token
  if ([511006, 511007].includes(e?.data?.code)) {
    localStorage.removeItem('token');

    // 清除token (B下C用户cookie和session中的token)
    removeToken();
  }
});

// 平台标识
window.platform = 7;

Vue.use(DomainStore);

export default new DomainStore.Store({
  state: {
    roomBaseServer: useRoomBaseServer().state,
    docServer: useDocServer().state,
    interactiveServer: useInteractiveServer().state,
    micServer: useMicServer().state,
    mediaSettingServer: useMediaSettingServer().state,
    virtualAudienceServer: useVirtualAudienceServer().state,
    userServer: useUserServer().state,
    groupServer: useGroupServer().state,
    desktopShareServer: useDesktopShareServer().state,
    splitScreenServer: useSplitScreenServer().state,
    insertFileServer: useInsertFileServer().state,
    mediaCheckServer: useMediaCheckServer().state,
    videoPollingServer: useVideoPollingServer().state,
    chatServer: useChatServer().state,
    playerServer: usePlayerServer().state,
    subscribeServer: useSubscribeServer().state,
    subjectServer: useSubjectServer().state,
    fileDownloadServer: useFileDownloadServer().state,
    aiServer: useAiServer().state,
    aiOutlineServer: useAiOutlineServer().state,
    goodServer: useGoodServer().state,
    playbackServer: usePlaybackServer().state
  }
});
